import { Activity, Building2, Database, LayoutGrid } from 'lucide-react';
import { formatNumber } from '../helpers';
import { Card } from '@/components/ui/card';

const KpiCards = ({ companies, catalogue, usage }) => {
  const entries = companies.map((company) => usage[company.uid] ?? {});
  const activeCompanies = entries.filter((features) => Object.values(features).some((entry) => entry.requests > 0)).length;
  const featuresInUse = catalogue.filter((feature) => entries.some((features) => features[feature.key]?.requests > 0)).length;
  const totalRequests = entries.reduce((sum, features) => sum + Object.values(features).reduce((s, entry) => s + entry.requests, 0), 0);
  const created = entries.reduce((sum, features) => sum + Object.values(features).reduce((s, entry) => s + (entry.footprint?.created_in_window ?? 0), 0), 0);

  const items = [
    { label: 'Active Companies', value: `${activeCompanies} of ${companies.length}`, icon: Building2 },
    { label: 'Features In Use', value: `${featuresInUse} of ${catalogue.length}`, icon: LayoutGrid },
    { label: 'Feature Requests', value: formatNumber(totalRequests), icon: Activity },
    { label: 'Records Created', value: formatNumber(created), icon: Database }
  ];

  return (
    <Card className="grid grid-cols-2 divide-x divide-y lg:grid-cols-4 lg:divide-y-0">
      {items.map((item) => (
        <div key={item.label} className="flex items-center gap-3 px-4 py-3">
          <item.icon className="h-4 w-4 shrink-0 text-muted-foreground" />
          <div>
            <div className="text-xs text-muted-foreground">{item.label}</div>
            <div className="text-lg font-semibold leading-tight">{item.value}</div>
          </div>
        </div>
      ))}
    </Card>
  );
};

export default KpiCards;
